/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
import React, { useMemo } from 'react';

import { Button, Icon, SectionHeader } from '@meterup/atto';
import { QuoteRequest } from '@meterup/connect-api';

interface QuotesContractNetworkProps {
  quoteRequest: QuoteRequest;
  onRequestNetwork: () => void;
}

function QuotesContractNetwork({ quoteRequest, onRequestNetwork }: QuotesContractNetworkProps) {
  const features = [
    'Wired',
    'Wi-Fi',
    'Cellular',
    'Security',
    'Installation',
    'Management & support',
    'Hardware buyback credit',
  ];

  const renderItem = (text: string) => (
    <div className="flex">
      <span className="text-gray-500 mr-2">
        <Icon icon="checkmark" />
      </span>
      <span className="text-sm ml-0 text-gray-600">{text}</span>
    </div>
  );

  const renderNetworkFeaturesSection = useMemo(
    () => (
      <ul className="text-left justify-between">
        {features.map((feature, index) => (
          <li className="mt-2 font-normal" key={index}>
            {renderItem(feature)}
          </li>
        ))}
      </ul>
    ),
    [],
  );

  const headerStart = (
    <div className="text-gray-700">
      <p className="font-bold text-lg text-gray-800">Your ISP is just the starting point.</p>
      <p className="text-md">Need help building out the rest of your network?</p>
      <p className="text-md">
        Meter can handle your network stack end-to-end for one monthly rate.
      </p>
    </div>
  );

  const headerEnd = (
    <Button variant="secondary" onClick={onRequestNetwork}>
      {quoteRequest.isInterestedInNetwork ? 'Skip for now' : 'Contact me'}
    </Button>
  );

  return (
    <section>
      <SectionHeader heading={headerStart} actions={headerEnd} />
      <div className="border border-gray-50 bg-gray-50 rounded-b-lg p-6 mt-nudge-1px">
        <div className="flex flex-row text-center sm:text-left items-center">
          <div className="flex-1">
            <img src="/assets/MeterNetworkLogo.svg" alt="Logo" width={200} />
            <div className="mt-6">{renderNetworkFeaturesSection}</div>
          </div>
          <div className="sm:pl-6 flex-1 text-center">
            <img
              src="/assets/MeterNetworkPedestals.png"
              alt="Illustration of the Meter hardware"
              title="Meter Network"
              className="inline-block"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default QuotesContractNetwork;
